const KL_DELIVERY_SELECTOR = '[data-kl-delivery]';
const KL_DELIVERY_DATE_SELECTOR = '[data-kl-delivery-date]';
const KL_DELIVERY_UPDATE_EVENT = 'kl:delivery:update';
const KL_DELIVERY_WEEKEND_DAYS = [0, 6];
const KL_DELIVERY_MAX_DAYS = 365;

function addCalendarDays(date, days) {
  const result = new Date(date.getTime());

  result.setDate(result.getDate() + days);

  return result;
}

function addBusinessDays(date, days) {
  let result = new Date(date.getTime());
  let remaining = days;

  while (remaining > 0) {
    result = addCalendarDays(result, 1);
    if (!KL_DELIVERY_WEEKEND_DAYS.includes(result.getDay())) remaining -= 1;
  }

  return result;
}

function getDeliveryDate(orderedAt, leadDays, isBusinessDaysOnly, cutoffHour) {
  const safeLeadDays = Math.min(Math.max(Number.parseInt(leadDays, 10) || 0, 0), KL_DELIVERY_MAX_DAYS);
  const hasMissedCutoff = Number.isFinite(cutoffHour) && orderedAt.getHours() >= cutoffHour;
  const startDate = hasMissedCutoff ? addCalendarDays(orderedAt, 1) : orderedAt;

  return isBusinessDaysOnly ? addBusinessDays(startDate, safeLeadDays) : addCalendarDays(startDate, safeLeadDays);
}

function formatDeliveryDate(date, locale, dateStyle) {
  const options = {
    weekday: { weekday: 'long', month: 'long', day: 'numeric' },
    short: { month: 'short', day: 'numeric' },
    long: { month: 'long', day: 'numeric' },
  };

  try {
    return new Intl.DateTimeFormat(locale, options[dateStyle] || options.long).format(date);
  } catch (error) {
    console.debug('kl-delivery-estimate: falling back to the default locale', { locale, dateStyle, error });
    return new Intl.DateTimeFormat(undefined, options.long).format(date);
  }
}

function getDeliveryText(earliest, latest, locale, dateStyle, separator) {
  const earliestText = formatDeliveryDate(earliest, locale, dateStyle);
  const latestText = formatDeliveryDate(latest, locale, dateStyle);

  return earliestText === latestText ? earliestText : `${earliestText} ${separator} ${latestText}`;
}

function renderDeliveryEstimate(root, overrides = {}) {
  const target = root.querySelector(KL_DELIVERY_DATE_SELECTOR);

  if (!target) return;
  if (root.dataset.klDeliveryPreOrder === 'true' && !overrides.text) {
    root.classList.add('is-ready');
    return;
  }

  try {
    if (overrides.text) {
      target.textContent = overrides.text;
      root.classList.add('is-ready');
      return;
    }

    const dataset = root.dataset;
    const orderedAt = new Date();
    const isBusinessDaysOnly = dataset.klDeliveryBusinessDays === 'true';
    const cutoffHour =
      dataset.klDeliveryUseCutoff === 'true' ? Number.parseInt(dataset.klDeliveryCutoffHour, 10) : null;

    const minDays = overrides.minDays ?? dataset.klDeliveryMinDays;
    const maxDays = overrides.maxDays ?? dataset.klDeliveryMaxDays;

    const earliest = getDeliveryDate(orderedAt, minDays, isBusinessDaysOnly, cutoffHour);
    const latest = getDeliveryDate(orderedAt, maxDays, isBusinessDaysOnly, cutoffHour);
    const locale = document.documentElement.lang || undefined;

    target.textContent = getDeliveryText(
      earliest,
      latest,
      locale,
      dataset.klDeliveryDateStyle,
      dataset.klDeliveryRangeSeparator || '–'
    );
    root.classList.add('is-ready');
  } catch (error) {
    console.debug('kl-delivery-estimate: could not work out a delivery date', {
      minDays: root.dataset.klDeliveryMinDays,
      maxDays: root.dataset.klDeliveryMaxDays,
      error,
    });
  }
}

function initDeliveryEstimate(root) {
  if (!root || root.dataset.klDeliveryReady === 'true') return;

  root.dataset.klDeliveryReady = 'true';

  root.addEventListener(KL_DELIVERY_UPDATE_EVENT, (event) => {
    renderDeliveryEstimate(root, event.detail || {});
  });

  renderDeliveryEstimate(root);
}

document.querySelectorAll(KL_DELIVERY_SELECTOR).forEach(initDeliveryEstimate);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll(KL_DELIVERY_SELECTOR).forEach(initDeliveryEstimate);
});
